module.exports = __webpack_public_path__ + "static/battle01-sq-3d36578c559ebc5551580e1662b5b6b0.png";